import { Briefcase, DollarSign, Compass } from "lucide-react";

const SERVICES = [
  { n: "01", title: "Landing Page Builder", desc: "Single-page builds for clients who need to launch fast." },
  { n: "02", title: "Website Setup Support", desc: "Help small businesses ship a modern site without a dev." },
  { n: "03", title: "Funnel Setup Support", desc: "Wire up lead capture + email automation for service providers." },
  { n: "04", title: "Intake Form Builder", desc: "Replace clunky email back-and-forth with one smart form." },
  { n: "05", title: "Dashboard Builder", desc: "Clean views of leads, revenue, and customers — no spreadsheets." },
  { n: "06", title: "AI Workflow Assistant", desc: "Automate one repeatable task that's eating someone's week." },
];

export default function SkillToIncome() {
  return (
    <section data-testid="skill-to-income-section" className="relative py-24 lg:py-32 bg-ink text-white overflow-hidden">
      <div className="absolute inset-0 grid-bg-soft opacity-[0.08] pointer-events-none" />
      <div className="relative max-w-[1240px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-8">
            <div className="font-mono-spec text-[11px] tracking-[0.22em] uppercase mb-5 font-medium" style={{ color: "#A8B3FF" }}>
              Skill &gt; Class
            </div>
            <h2 className="font-display text-[44px] sm:text-5xl lg:text-[72px] leading-[1.02] tracking-[-0.035em]">
              Learn a skill you can use{" "}
              <span className="font-serif-em italic font-light" style={{ color: "#A8B3FF" }}>beyond</span>{" "}
              this class.
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-[17px] leading-relaxed text-white/70">
              This is bigger than one website. This is about learning how to{" "}
              <strong className="text-white">think, prompt, plan, and build</strong>{" "}
              digital tools that businesses already need.
            </p>
          </div>
        </div>

        <div className="rounded-3xl bg-brand p-10 lg:p-14 mb-14 relative overflow-hidden">
          <div className="absolute -top-32 -right-20 w-96 h-96 rounded-full" style={{ background: "radial-gradient(circle, rgba(255,255,255,0.18), transparent 60%)" }} />
          <div className="absolute -bottom-32 -left-20 w-96 h-96 rounded-full" style={{ background: "radial-gradient(circle, rgba(255,255,255,0.08), transparent 60%)" }} />
          <div className="relative grid md:grid-cols-3 gap-8 md:gap-12">
            <Pillar icon={Briefcase} title="Learn it" body="For your business." />
            <Pillar icon={DollarSign} title="Use it" body="For your income." />
            <Pillar icon={Compass} title="Build it" body="For your future." />
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SERVICES.map((s, i) => (
            <div key={s.title} data-testid={`service-${i}`} className="p-7 rounded-2xl bg-white/[0.04] border border-white/10 transition-all hover:bg-white/[0.08] hover:border-white/25 hover:-translate-y-0.5">
              <div className="font-mono-spec text-[11px] mb-5 tracking-wider" style={{ color: "#A8B3FF" }}>{s.n}</div>
              <h3 className="font-display text-xl tracking-[-0.02em] mb-2 leading-snug">{s.title}</h3>
              <p className="text-sm text-white/60 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        <p className="mt-12 text-sm text-white/55 max-w-3xl leading-relaxed italic">
          This course does not guarantee income. It gives you a practical skill foundation you can continue practicing, improving, and packaging into service opportunities &mdash; with continued practice, confidence, and implementation.
        </p>
      </div>
    </section>
  );
}

function Pillar({ icon: Icon, title, body }) {
  return (
    <div className="flex flex-col">
      <div className="w-12 h-12 rounded-xl bg-white/15 grid place-items-center text-white mb-5">
        <Icon size={22} strokeWidth={1.5} />
      </div>
      <div className="font-display text-4xl tracking-[-0.03em] mb-1.5">{title}</div>
      <div className="text-white/85 text-lg">{body}</div>
    </div>
  );
}
